export function formatAmount(amount: number, currency: string = "GBP") {
  return Intl.NumberFormat(Office.context.displayLanguage, {
    currency,
    style: "currency",
  }).format(amount);
}
